/* LA PRENDA VUELA A LA BOLSA · 27-ago-2026
 *
 * 🔴 QUÉ RESUELVE. Tocar "Agregar" abría una confirmación y subía el número de
 * la cabecera, pero nada CONECTABA las dos cosas: la clienta leía un aviso y,
 * si acaso, notaba que un número cambió en una esquina. El vuelo dice de dónde
 * salió y adónde fue en el único idioma que no hay que leer.
 *
 * 🔴 ES UN CLON, NO LA FOTO. La original se queda intacta en la galería: si se
 * moviera la de verdad, la ficha se desarmaría a media animación y habría que
 * devolverla a su sitio. El clon vive en el `<body>`, `position: fixed`, y se
 * borra al llegar. Si algo falla a medias, lo peor que queda es una imagen
 * suelta que el reloj retira igual.
 *
 * 🔴 EL ARCO SE HACE CON DOS CAPAS, y es lo que separa esto de un truco de app.
 * Un solo elemento animado va en línea recta. Aquí el envoltorio se ocupa de la
 * X y la imagen de dentro de la Y, cada uno con su curva: la horizontal es
 * pareja, la vertical arranca lenta y se acelera. La suma de las dos es una
 * parábola — sube un poco antes de caer a la bolsa. Es el mismo principio con
 * el que se anima cualquier cosa que se lanza.
 *
 * 🔴 SI LA BOLSA NO SE VE, NO HAY VUELO. La cabecera se esconde al bajar; con
 * el destino fuera de pantalla la foto saldría volando hacia la nada. Ahí se
 * calla y el pulso de la pastilla hace su trabajo cuando la cabecera vuelva.
 */
(function () {
  'use strict';

  var DUR = 620;                                    /* el viaje completo */
  var CURVA_X = 'cubic-bezier(0.4, 0, 0.6, 1)';     /* pareja: es un traslado */
  var CURVA_Y = 'cubic-bezier(0.6, 0, 0.9, 0.6)';   /* acelera: es una caída */

  function quieto() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function seVe(r) {
    return r.width > 0 && r.height > 0 &&
      r.top < innerHeight && r.bottom > 0 && r.left < innerWidth && r.right > 0;
  }

  function lanza(origen, destino) {
    if (quieto() || !origen || !destino) return;

    var ro = origen.getBoundingClientRect();
    var rd = destino.getBoundingClientRect();
    if (!seVe(ro) || !seVe(rd)) return;

    /* 🔴 TRES CAPAS, UNA POR TRABAJO — y no es purismo, es aritmética.
       El primer intento puso la X en el envoltorio y la Y en la imagen, con la
       escala también en el envoltorio. Como la imagen va DENTRO, la escala del
       padre multiplicaba su desplazamiento vertical: la prenda caía a `dy` por
       la escala, o sea muy corto, y no llegaba a la bolsa.
       Separando ejes, cada `translate` va en píxeles sobre un elemento sin
       escalar, y la escala se queda sola en la imagen del fondo. */
    var capaX = document.createElement('div');   /* solo la horizontal */
    capaX.setAttribute('aria-hidden', 'true');
    capaX.style.cssText =
      'position:fixed;left:' + ro.left + 'px;top:' + ro.top + 'px;' +
      'width:' + ro.width + 'px;height:' + ro.height + 'px;' +
      'z-index:200;pointer-events:none;will-change:transform;';

    var capaY = document.createElement('div');   /* solo la vertical */
    capaY.style.cssText = 'width:100%;height:100%;will-change:transform;';

    var foto = document.createElement('img');
    foto.src = origen.currentSrc || origen.src;
    foto.alt = '';
    foto.style.cssText =
      'display:block;width:100%;height:100%;object-fit:cover;' +
      'max-width:none;will-change:transform,opacity;';

    capaY.appendChild(foto);
    capaX.appendChild(capaY);
    document.body.appendChild(capaX);

    var dx = (rd.left + rd.width / 2) - (ro.left + ro.width / 2);
    var dy = (rd.top + rd.height / 2) - (ro.top + ro.height / 2);
    /* No se encoge hasta el tamaño exacto de la pastilla —quedaría en 4 píxeles
       y el ojo lo pierde antes de llegar—: se para en un 12% legible. */
    var escala = Math.max(rd.width / ro.width, 0.12);

    /* Dos cuadros, o el navegador no tiene estado inicial que interpolar. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        capaX.style.transition = 'translate ' + DUR + 'ms ' + CURVA_X;
        capaX.style.translate = dx + 'px 0';

        capaY.style.transition = 'translate ' + DUR + 'ms ' + CURVA_Y;
        capaY.style.translate = '0 ' + dy + 'px';

        /* La imagen se encoge durante todo el viaje y solo se apaga al final:
           desvanecerla desde el principio la borra a media pantalla y se pierde
           el sentido del recorrido. */
        foto.style.transition = 'scale ' + DUR + 'ms ' + CURVA_X +
                                ', opacity ' + Math.round(DUR * 0.4) + 'ms linear ' +
                                Math.round(DUR * 0.6) + 'ms';
        foto.style.scale = escala;
        foto.style.opacity = '0';
      });
    });

    /* Reloj y no `transitionend`: son tres elementos con sus transiciones y
       basta con que un evento se pierda para dejar una foto pegada encima de la
       página, tapando el botón de pagar. */
    setTimeout(function () {
      if (capaX.parentNode) capaX.parentNode.removeChild(capaX);
    }, DUR + 120);
  }

  window.AvoraVuelo = { lanza: lanza };
})();
